<script setup>
import { nextTick, onMounted, ref, watch } from "vue";
import {
  drawBallPreview,
  drawPaddlePreview
} from "@/game/runtime/ui/skinView.js";

const props = defineProps({
  category: { type: String, required: true },
  type: { type: String, default: "default" }
});

const canvas = ref(null);

function renderPreview() {
  const el = canvas.value;
  if (!el) return;

  const cssWidth = 118;
  const cssHeight = 78;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  el.width = Math.round(cssWidth * dpr);
  el.height = Math.round(cssHeight * dpr);
  el.style.width = `${cssWidth}px`;
  el.style.height = `${cssHeight}px`;

  const ctx = el.getContext("2d");
  if (!ctx) return;
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  ctx.clearRect(0, 0, cssWidth, cssHeight);

  if (props.category === "ball") {
    // 与实际游戏运行时使用同一个绘制函数，避免商店预览和游戏内皮肤不一致。
    drawBallPreview(ctx, cssWidth / 2, cssHeight / 2, 27, props.type || "default");
  } else {
    drawPaddlePreview(ctx, cssWidth / 2, cssHeight / 2, 94, 22, props.type || "default");
  }
}

onMounted(() => nextTick(renderPreview));
watch(() => [props.category, props.type], () => nextTick(renderPreview));
</script>

<template>
  <canvas ref="canvas" class="skin-preview-canvas" aria-hidden="true" />
</template>

<style scoped>
.skin-preview-canvas {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}
</style>
